// extracted by mini-css-extract-plugin
module.exports = {"footer":"_index-footer-3lFM","copyright":"_index-copyright-r6zP","link":"_index-link-15Mf"};